import React, { Component } from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
// import Autosuggest from "react-autosuggest";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import { taxServiceClient } from "../../AxiosClient";
import { withTranslation } from "react-i18next";
import Autocomplete from "@material-ui/lab/Autocomplete";
const styles = (theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  suggestionsContainerOpen: {
    position: "absolute",
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
    zIndex: 9999,
  },
  suggestion: {
    display: "block",
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: "none",
  },
  documentDialog: {
    minHeight: 400,
    minWidth: 400,
    overflow: "visible",
  },
});

export class TopicAutosuggest extends Component {
  state = {
    topicSuggestions: [],
    topicAutocompleteLoading: false,
    topicSuggestInput: "",
    value: "",
  };

  render() {
    const { classes, t } = this.props;
    return (
      <div>
        {/* <Autosuggest
          // autoSelect
          suggestions={this.state.topicSuggestions}
          onSuggestionsFetchRequested={this.onTopicSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onTopicSuggestionsClearRequested}
          getSuggestionValue={this.getTopicSuggestionValue}
          renderSuggestion={this.renderTopicSuggestion}
          // theme={{
          //   container: classes.container,
          //   suggestionsContainerOpen: classes.suggestionsContainerOpen,
          //   suggestionsList: classes.suggestionsList,
          //   suggestion: classes.suggestion,
          // }}
          inputProps={{
            placeholder: this.props.t("topic_autosuggest_choose"),
            value: this.state.topicSuggestInput,
            onChange: this.handleTopicSuggestChange,
          }}
          renderSuggestionsContainer={(options) => (
            <Paper
              {...options.containerProps}
              square
              elevation="10"
              style={{ width: "90%", marginLeft: 10, marginBottom: 10 }}
            >
              {options.children}
            </Paper>
          )}
          // renderInputComponent={(inputProps) => {
          //   const { classes, inputRef = () => {}, ref, ...other } = inputProps;
          //   return (
          //     <div>
          //       <TextField
          //         fullWidth
          //         InputProps={{
          //           inputRef: (node) => {
          //             ref(node);
          //             inputRef(node);
          //           },
          //         }}
          //         {...other}
          //       />
          //       {this.state.topicAutocompleteLoading && (
          //         <LinearProgress color="secondary" />
          //       )}
          //     </div>
          //   );
          // }}
        /> */}

        <Autocomplete
          handleHomeEndKeys
          fullWidth
          openOnFocus
          options={this.state.topicSuggestions}
          onChange={(e, selected) => {
            this.props.onItemSelected(selected);
          }}
          getOptionSelected={(op, val) => {
            return op.topicName === val.topicName;
          }}
          renderOption={(option, { selected }) => (
            <Paper
              square
              elevation="0"
              style={{ width: "90%", marginLeft: 10, marginBottom: 10 }}
            >
              {option.topicName}
            </Paper>
          )}
          inputValue={this.state.value}
          onInputChange={this.handleTopicSuggestChange}
          getOptionLabel={(option) => option.topicName}
          renderInput={(params) => (
            <>
              <TextField
                {...params}
                variant="standard"
                label={this.props.t("topic_autosuggest_choose")}
              />{" "}
              {this.state.topicAutocompleteLoading && (
                <LinearProgress color="secondary" />
              )}
            </>
          )}
        />
      </div>
    );
  }
  // getTopicSuggestionValue = (suggestion) => {
  //   return suggestion.topicName;
  // };

  handleTopicSuggestChange = (_e, newValue) => {
    if (_e && _e.type === "change") {
      this.props.onFilterChange(newValue);
      this.setState({ topicSuggestInput: newValue });
      this.onTopicSuggestionsFetchRequested(newValue);
    }
  };

  onTopicSuggestionsFetchRequested = (value) => {
    if (value || value === "") {
      this.setState({ value });
      if (value) {
        if (this.timeout) {
          // only need the latest request queued
          window.clearTimeout(this.timeout);
        }

        this.setState({ topicAutocompleteLoading: true });

        // queue the request so we don't machine gun them at the backend
        this.timeout = window.setTimeout(() => {
          taxServiceClient
            .get("/topic/", {
              params: {
                search: value,
                orgId: this.props.organizationId,
              },
            })
            .then((res) => {
              this.setState({ topicSuggestions: res.data.content }, () =>
                this.setState({ topicAutocompleteLoading: false })
              );
              //if the input exactly matches a single result we select it
              res.data.content.length === 1 &&
                res.data.content[0].topicName ===
                  this.state.topicSuggestInput &&
                this.props.onItemSelected(res.data.content[0]);
            });
          // clear the queue
          this.timeout = null;
        }, 750);
      }
    }
  };

  renderTopicSuggestion = (suggestion, { query, isHighlighted }) => {
    return (
      <MenuItem
        selected={isHighlighted}
        component="div"
        onClick={() => this.props.onItemSelected(suggestion)}
      >
        <Typography noWrap>{suggestion.topicName}</Typography>
      </MenuItem>
    );
  };

  onTopicSuggestionsClearRequested = () => {
    this.setState({ topicSuggestions: [] });
  };
}
export default withStyles(styles)(withTranslation()(TopicAutosuggest));
